import React from 'react';
import styles from './LedPanel.module.css';

/**
 * LedPanel — bezel físico de la pantalla LED.
 * Recibe un canvasRef y renderiza el marco sin lógica de animación.
 */
export default function LedPanel({ canvasRef }) {
  return (
    <div className={styles.bezel}>
      <div className={styles.screws}>
        <span /><span /><span /><span />
      </div>
      <div className={styles.panel}>
        <canvas ref={canvasRef} className={styles.canvas} />
      </div>
      <div className={styles.bezelFoot}>
        <span className={styles.bezelBrand}>MICROLED · FULL COLOR</span>
        <span className={styles.bezelDots}>
          <span style={{ background: '#cb3234' }} />
          <span style={{ background: '#f0a000' }} />
          <span style={{ background: '#4caf50' }} />
        </span>
      </div>
    </div>
  );
}
